import React, { useState } from 'react';
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import useLoginHooks from './hooks';

export const Login = () => {
  const { classes, onSubmit, errors, control } = useLoginHooks();
  const [showPassword, setShowPassword] = useState(false);
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper className={classes.paper}>
          <form onSubmit={onSubmit}>
            <Grid container justifyContent="space-around" alignItems="center">
              <Grid container justifyContent="space-around" alignItems="center">
                <FormControl fullWidth>
                  <Controller
                    name="accountToken"
                    defaultValue=""
                    render={({ onChange, value }) => (
                      <TextField
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword((s) => !s)}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        className={classes.input}
                        type={showPassword ? 'text' : 'password'}
                        variant="outlined"
                        label="Account Token"
                        error={errors?.accountToken}
                        value={value}
                        onChange={({ target }) => {
                          onChange(target.value);
                        }}
                      />
                    )}
                    control={control}
                  />
                </FormControl>
              </Grid>
              <Grid container justifyContent="flex-end" alignItems="center">
                <Button
                  type="submit"
                  variant="contained"
                  disableElevation
                  className={classes.blueButton}
                >
                  Login
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </div>
    </>
  );
};

export default Login;
